import { Button } from '@design-system/button';
import { DangerouslySetInnerHtml } from '@phx-husky/dangerously-set-inner-html';
import classNames from 'classnames';
import React, { FC, Fragment, useMemo } from 'react';

import { AccordionProps, TitleContent } from '../models';

interface AccordionTitleProps
  extends Omit<AccordionProps, 'items' | 'onChange' | 'title'> {
  isOpen: boolean;
  onToggle: () => void;
  title: TitleContent;
  disabled?: boolean;
}

export const AccordionTitle: FC<AccordionTitleProps> = ({
  isOpen,
  headlineTag = Fragment,
  openIcon = { icon: 'add' },
  closeIcon = { icon: 'close' },
  semanticVariant,
  onToggle,
  title,
  ...rest
}) => {
  const TitleTag = useMemo(
    () => (semanticVariant === 'dl' ? 'dt' : 'div'),
    [semanticVariant]
  );
  const HeadlineTag = useMemo(
    () => (semanticVariant === 'dl' ? Fragment : headlineTag),
    [headlineTag, semanticVariant]
  );

  const titleChild: string | number | React.ReactElement =
    typeof title === 'string' ? (
      <DangerouslySetInnerHtml html={title} />
    ) : (
      title
    );

  return (
    <TitleTag className="cds-accordion__opener">
      <HeadlineTag>
        <Button
          iconPrefix={{
            props: {
              icon: !isOpen ? openIcon.icon : closeIcon.icon,
              classNameContainer: `accordion-item__${
                isOpen ? 'close' : 'open'
              }-icon`,
              isWrapped: true,
            },
          }}
          variant="subtle"
          size="large"
          onClick={onToggle}
          aria-expanded={isOpen}
          className={classNames({
            active: isOpen,
          })}
          {...rest}
        >
          {titleChild}
        </Button>
      </HeadlineTag>
    </TitleTag>
  );
};
